<template>
  <div class="">
    <trac-loading v-if="isLoading" />
    <div v-if="showWrongPinWarning"
      class="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-black bg-opacity-75">
        <trac-incorrect-pin 
          @cancel="showWrongPinWarning = false" 
          :message="wrongPinWarning.message" 
          :blocked="wrongPinWarning.blocked" 
          @forgot-password="$router.push({name: 'ConfirmPassword', query:{ops: 'forgot_wallet_pin'}})"
        />
    </div>
    
    <div v-if="showUnsanctionedDeviceModal"
      class="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-black bg-opacity-75">
      <div class="rounded-md bg-white gap-y-5 p-12 w-4/12 flex flex-col content-center text-center">
        <div class="text-center"><img class="w-12 h-12 inline-block" src="@/assets/banned.svg" alt=""></div>
        <h3 class="font-bold">Unauthorized</h3>
        <p class="text-xs">You are not authorized to perform the selected action</p>
        <div></div>
        <trac-button class="uppercase" @button-clicked="$router.push({name: 'Dashboard'})">Back to Home</trac-button>
      </div>
    </div>

    <trac-modal v-if="showPasswordModal">
      <h3 class="my-5 font-bold text-center text-primaryBlue">Session Expired</h3>
      <p class="text-xs text-center">
        Please enter your Traction password to resume your progress
      </p>
      <trac-input
        v-model.trim="payload.password"
        type="password"
        placeholder="Password"
        specified="password"
        class="mt-6 w-full md:w-128"
        tag="div"
      />
      <div class="text-center mt-5">
        <trac-button @button-clicked="reVerify()">Proceed</trac-button>
      </div>
    </trac-modal>
    <!-- Create an overlay in Tailwind that is 50% transparent and covers the whole screen -->
    <div v-if="!hasPinChanged && hasSetupWallet"
      class="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-black bg-opacity-75">
      <!-- Create a vertically and horizontally centered div with 15px padding on all sides with md round corners -->
      <div class="bg-white rounded-md py-8 px-10 flex flex-col items-center">
          <img src="@/assets/pin-check-warning.svg" class="w-20 h-20" alt="" />
          <h2 class=" text-base font-semibold">Reset PIN</h2>
          <p class="text-xs text-gray-600 text-center mt-2 mb-6">Please Reset your pin to make a transaction</p>
          <trac-button @button-clicked="$router.push({name: 'ConfirmPassword',query: {ops: 'forgot_wallet_pin',},})" class="py-2 px-4 uppercase">Click here</trac-button>
      </div>
    </div>
    
    <div class="mt-10 w-full" v-if="walletDetails">
      <div class="flex justify-between items-center flex-wrap">
        <trac-back-button class="pb-4">
          <span class="text-gray-600"> Home </span>
        </trac-back-button>
        <!-- @click.native="$router.push({ name: 'CreateWallet' })" -->
        <trac-button
          v-if="!walletDetails.walletid"
          @button-clicked="$router.push({ name: 'Kyc' })"
          class="uppercase"
          data-test="create-wallet"
          variant="outline"
        >
          <span>
            Create Wallet
          </span>
        </trac-button>
      </div>
      <div class="flex gap-12 mt-4">
        <div class="p-5 rounded-lg shadow-md bg-primaryBlue" style="width: 60%">
          <div class="flex">
            <svg
              class="w-10 h-10"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="48"
                height="48"
                rx="24"
                fill="white"
                fill-opacity="0.08"
              />
              <path
                d="M15 19H32V16.2626C32 15.6178 31.3987 15.1415 30.771 15.2892L15 19Z"
                fill="#B4E6FF"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M33 33H15C14.45 33 14 32.55 14 32V20C14 19.45 14.45 19 15 19H33C33.55 19 34 19.45 34 20V32C34 32.55 33.55 33 33 33Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M34 28H30C28.9 28 28 27.1 28 26C28 24.9 28.9 24 30 24H34V28Z"
                fill="#B4E6FF"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              class="flex flex-col mt-3 self-center ml-3 text-xs text-white w-full"
            >
              <p>Wallet Balance</p>
              <div
                class="text-3xl font-semibold flex justify-between w-full items-center"
              >
                <div>
                  {{ walletDetails.amount | formatPrice(false) }}
                </div>
                <div>
                  <!-- @click="fundWalletModal = true" -->
                  <svg
                    @click="transferToSettlementAccount"
                    class="w-10 h-10 mr-10"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="24" cy="24" r="24" fill="white" />
                    <path
                      d="M24 15.6001V32.4001"
                      stroke="#0140A3"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.6001 24H32.4001"
                      stroke="#0140A3"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <!-- Account No. : xxxxxxxxxxx -->
            </div>
          </div>
        </div>
        <div
          class="py-5 px-8 rounded-lg border shadow-md text-xs"
          style="width: 40%"
        >
          <p class="font-semibold">Quick Links</p>
          <div class="flex flex-wrap justify-between w-full mt-3">
            <div
              @click="openBeneficiary"
              class="flex items-center flex-col cursor-pointer justify-center"
            >
              <img
                class="w-10 h-10"
                src="@/assets/svg/make_transfer.svg"
                alt=""
              />
              <p
                style="font-size: 0.7rem"
                class="text-center mt-2 leading-3 text-gray-700"
              >
                Transfer
              </p>
            </div>
            <div
              @click="openBuyAirtimeModal"
              class="flex items-center flex-col cursor-pointer justify-center"
            >
              <img
                class="w-10 h-10"
                src="@/assets/svg/buy_airtime.svg"
                alt=""
              />
              <p
                style="font-size: 0.7rem"
                class="text-center mt-2 leading-3 text-gray-700"
              >
                Airtime / Data
              </p>
            </div>
            <div
              @click="$router.push({ name: 'PayBills' })"
              class="flex items-center flex-col cursor-pointer justify-center"
            >
              <svg
                class="w-10 h-10"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="48" height="48" rx="4.8" fill="#EFFAFD" />
                <path
                  d="M17.4243 23.644C17.6126 23.644 17.7652 23.7967 17.7652 23.9849C17.7652 24.1732 17.6126 24.3259 17.4243 24.3259C17.236 24.3259 17.0834 24.1732 17.0834 23.9849C17.0834 23.7967 17.236 23.644 17.4243 23.644"
                  stroke="#003283"
                  stroke-width="1.08"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.0607 30.4621C31.249 30.4621 31.4017 30.6148 31.4017 30.8031C31.4017 30.9913 31.249 31.144 31.0607 31.144C30.8725 31.144 30.7198 30.9913 30.7198 30.8031C30.7198 30.6148 30.8725 30.4621 31.0607 30.4621"
                  stroke="#003283"
                  stroke-width="1.08"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <rect
                  x="14.0151"
                  y="20.5758"
                  width="20.4545"
                  height="13.6364"
                  rx="1.22727"
                  stroke="#003283"
                  stroke-width="1.08"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle
                  cx="24.2424"
                  cy="27.3939"
                  r="2.72727"
                  fill="#B4E6FF"
                  stroke="#003283"
                  stroke-width="1.08"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.3789 17.8486H33.1062"
                  stroke="#003283"
                  stroke-width="1.08"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.1062 15.1212H30.3789"
                  stroke="#003283"
                  stroke-width="1.08"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <p
                style="font-size: 0.7rem"
                class="text-center mt-2 leading-3 text-gray-700"
              >
                Pay Bills
              </p>
            </div>
            <div
              @click="$router.push({ name: 'PinManagment' })"
              class="flex items-center flex-col cursor-pointer justify-center"
            >
              <img
                class="w-10 h-10"
                src="@/assets/svg/account_statement.svg"
                alt=""
              />
              <p
                style="font-size: 0.7rem"
                class="text-center mt-2 leading-3 text-gray-700"
              >
                PIN Setup
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="p-4 wallet-bg flex-1 rounded-lg">
          <div class="grid grid-cols-2 items-center">
            <div class="flex flex-1 items-center">
              <img
                src="@/assets/svg/wallet_house.svg"
                class="w-20 h-20"
                alt=""
              />
              <div class="ml-3">
                <h1 class="text-xs text-primaryGray">Balance</h1>
                <div class="text-xl uppercase font-medium md:mb-0 mb-5">
                  {{ walletDetails.amount | formatPrice(false) }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-end items-end">
            <trac-button @button-clicked="transferToSettlementAccount"
              >Transfer to settlement Account</trac-button
            >
          </div>
        </div>
        <div class="p-5 wallet-bg flex-1 rounded-lg">
          <h1 class="text-lg font-medium">Quick Links</h1>
          <div class="flex justify-between px-5 h-full pb-4 items-center">
            <div
              class="flex justify-center items-center flex-col cursor-pointer"
              @click="openBeneficiary"
            >
              <img src="@/assets/svg/make_transfer.svg" alt="" />
              <p class="text-xs text-center mt-2 leading-4">
                Make <br />
                Transfer
              </p>
            </div>
            <div
              @click="openBuyAirtimeModal"
              class="flex justify-center items-center flex-col cursor-pointer"
            >
              <img src="@/assets/svg/buy_airtime.svg" alt="" />
              <p class="text-xs text-center mt-2 leading-4">
                Buy <br />
                Airtime
              </p>
            </div>

            <div
              class="flex justify-center items-center flex-col cursor-pointer"
              @click="$router.push({ name: 'PinManagment' })"
            >
              <img  alt="" />
              <p class="text-xs text-center mt-2 leading-4">
                PIN <br />
                Management
              </p>
            </div>
          </div>
        </div> -->
    </div>

    <div
      style="border-width: 1px"
      class="bg-blue-100 text-primaryBlue text-center py-3 border-blue-200 mt-10 rounded"
    >
      Do you know you can start saving from your transactions daily to grow your
      business?
      <span
        @click="$router.push({ name: 'SavingsWaitlist' })"
        class="font-medium cursor-pointer"
        >Learn More</span
      >
    </div>

    <div class="mt-10">
      <div class="mt-5 mb-2 text-xl">Transactions</div>
      <div class="grid md:flex md:justify-between items-end">
        <div class="md:w-1/2 mb-3 md:mb-0">
          <trac-dropdown-exteneded
            :neededProperty="'name'"
            :options="timespan"
            :selector="timespan[0].name"
            @optionSelected="selectTimeline($event)"
          ></trac-dropdown-exteneded>
        </div>

        <div class="">
          <button
            @click="selectedFilter = 'all'"
            style="outline: none"
            class="text-xs outline-none border-0 text-primaryBlue border-primaryBlue px-6 py-2"
            :class="selectedFilter == 'all' ? 'border-b-2' : ''"
          >
            All
          </button>
          <button
            @click="selectedFilter = 'in'"
            style="outline: none"
            class="text-xs outline-none border-0 text-primaryBlue border-primaryBlue px-6 py-2"
            :class="selectedFilter == 'in' ? 'border-b-2' : ''"
          >
            In
          </button>
          <button
            @click="selectedFilter = 'out'"
            style="outline: none"
            class="text-xs outline-none border-0 text-primaryBlue border-primaryBlue px-6 py-2"
            :class="selectedFilter == 'out' ? 'border-b-2' : ''"
          >
            Out
          </button>
        </div>
      </div>

      <div class="md:hidden overflow-scroll max-table-height">
        <div
          class="text-xs py-4"
          v-for="(transaction, i) in filteredTransactions"
          :key="i"
        >
          <p class="mb-2 text-gray-600">
            {{ moment(transaction.updatedOn).format('DD MMM YYYY') }}
          </p>
          <div class="flex justify-between">
            <p class="">{{ transaction.craccountname }}</p>
            <span
              class="font-bold"
              :class="transaction.isCredit ? 'text-green-500' : 'text-red-500'"
              >{{ transaction.isCredit ? '+' : '-' }}<span class=""></span>
              {{ transaction.amount | formatPrice }}</span
            >
          </div>
          <div class="">
            <p
              class="small mt-1 font-bold"
              :class="transaction.isCredit ? 'text-green-500' : 'text-red-500'"
            >
              {{ transaction.transactiontypedisplaytext }}
            </p>
          </div>
          <div class="flex justify-end">
            <button
              class="font-bold text-primaryBlue outline-none"
              @click="openWalletTransaction(transaction)"
            >
              View details
            </button>
          </div>
        </div>
        <div
          v-if="filteredTransactions.length === 0"
          class="flex justify-center items-center h-60 text-sm"
        >
          No transactions added yet.
        </div>
      </div>
      <div class="w-full overflow-scroll max-table-height hidden md:block">
        <table class="w-full">
          <caption class="sr-only">Transactions</caption>
          <thead>
            <tr class="bg-accentLight">
              <th class="text-xs text-left px-2 py-4">Name</th>
              <!-- <th class="text-xs text-left px-2 py-4">Payment Method</th> -->
              <th class="text-xs text-left px-2 py-4">Date</th>
              <th class="text-xs text-left px-2 py-4">Transaction ID</th>
              <th class="text-xs text-left px-2 py-4">Amount</th>
              <!-- <th class="text-xs text-left px-2 py-4">Balance</th> -->
            </tr>
          </thead>
          <tbody v-if="filteredTransactions.length > 0">
            <tr
              v-for="(transaction, i) in filteredTransactions"
              :key="i"
              @click="openWalletTransaction(transaction)"
              class="cursor-pointer hover:bg-veryLight"
            >
              <td class="text-xs p-3 flex items-center">
                <div
                  class="smallest h-8 w-8 flex justify-center items-center rounded-full mr-4 bg-accentLight"
                >
                  <div v-if="transaction.craccountname" class="tiny text-accentDark cursor-pointer uppercase">
                    {{
                      transaction.craccountname
                        .split(' ')
                        .map((name) => name.substring(0, 1))
                        .join('')
                    }}
                  </div>
                  <div v-else class="tiny text-accentDark cursor-pointer uppercase">
                    N/A
                  </div>
                </div>
                <span class="font-extrabold">
                  {{ transaction.craccountname || 'N/A' }}
                </span>
              </td>
              <!-- <td class="text-xs p-3">{{ transaction.paymentMethod }}</td> -->
              <td class="text-xs p-3">
                {{ moment(transaction.updatedOn).format('DD MMM YYYY') }}
              </td>
              <td class="text-xs p-3">{{ transaction.reference }}</td>
              <td
                class="text-xs p-3 font-bold"
                :class="
                  transaction.isCredit ? 'text-green-500' : 'text-red-500'
                "
              >
                {{ transaction.isCredit ? '+' : '-' }}<span class=""></span>
                {{ transaction.amount | formatPrice }}
              </td>
              <!-- <td class="text-xs p-3 font-bold">
                {{ transaction.lastBalance | formatPrice }}
              </td> -->
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="">
                <div class="flex justify-center items-center h-60 text-sm">
                  No transactions added yet.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mt-10 pr-8">
      <div class="mt-5 mb-2 text-xl">Statement</div>
      <div class="bg-white big-shadow rounded-md py-6 px-8 w-full">
        <h1 class="font-medium">WALLET STATEMENT</h1>
        <p class="font-light mt-2">Select date range to download statement</p>
        <DateFilter
          class="mt-5 bg-white"
          v-model="date"
          @updateName="update"
          :currentName="currentName"
        />
        <div class="flex justify-center mt-10 mb-5 items-center">
          <trac-button @click.native="downloadStatement">
            <div class="lg:px-10">Download Statement</div>
          </trac-button>
        </div>
      </div>
    </div>
    <trac-modal size=" max-w-xs" :cancel="false" v-if="confirmation">
      <div class="flex justify-center items-center mt-10">
        <svg
          v-if="success"
          width="65"
          viewBox="0 0 106 85"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="53"
            cy="21"
            r="20.0553"
            stroke="#01368A"
            stroke-width="1.8894"
          />
          <path
            d="M62 15L49 28L43 22"
            stroke="#01368A"
            stroke-width="1.8894"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.634 78.216C4.626 78.216 3.66 78.084 2.736 77.82C1.812 77.544 1.068 77.19 0.504 76.758L1.494 74.562C2.034 74.946 2.67 75.264 3.402 75.516C4.146 75.756 4.896 75.876 5.652 75.876C6.228 75.876 6.69 75.822 7.038 75.714C7.398 75.594 7.662 75.432 7.83 75.228C7.998 75.024 8.082 74.79 8.082 74.526C8.082 74.19 7.95 73.926 7.686 73.734C7.422 73.53 7.074 73.368 6.642 73.248C6.21 73.116 5.73 72.996 5.202 72.888C4.686 72.768 4.164 72.624 3.636 72.456C3.12 72.288 2.646 72.072 2.214 71.808C1.782 71.544 1.428 71.196 1.152 70.764C0.888 70.332 0.756 69.78 0.756 69.108C0.756 68.388 0.948 67.734 1.332 67.146C1.728 66.546 2.316 66.072 3.096 65.724C3.888 65.364 4.878 65.184 6.066 65.184C6.858 65.184 7.638 65.28 8.406 65.472C9.174 65.652 9.852 65.928 10.44 66.3L9.54 68.514C8.952 68.178 8.364 67.932 7.776 67.776C7.188 67.608 6.612 67.524 6.048 67.524C5.484 67.524 5.022 67.59 4.662 67.722C4.302 67.854 4.044 68.028 3.888 68.244C3.732 68.448 3.654 68.688 3.654 68.964C3.654 69.288 3.786 69.552 4.05 69.756C4.314 69.948 4.662 70.104 5.094 70.224C5.526 70.344 6 70.464 6.516 70.584C7.044 70.704 7.566 70.842 8.082 70.998C8.61 71.154 9.09 71.364 9.522 71.628C9.954 71.892 10.302 72.24 10.566 72.672C10.842 73.104 10.98 73.65 10.98 74.31C10.98 75.018 10.782 75.666 10.386 76.254C9.99 76.842 9.396 77.316 8.604 77.676C7.824 78.036 6.834 78.216 5.634 78.216ZM17.4855 78.144C16.6815 78.144 15.9615 77.988 15.3255 77.676C14.7015 77.364 14.2155 76.89 13.8675 76.254C13.5195 75.606 13.3455 74.784 13.3455 73.788V68.316H16.1535V73.374C16.1535 74.178 16.3215 74.772 16.6575 75.156C17.0055 75.528 17.4915 75.714 18.1155 75.714C18.5475 75.714 18.9315 75.624 19.2675 75.444C19.6035 75.252 19.8675 74.964 20.0595 74.58C20.2515 74.184 20.3475 73.692 20.3475 73.104V68.316H23.1555V78H20.4915V75.336L20.9775 76.11C20.6535 76.782 20.1735 77.292 19.5375 77.64C18.9135 77.976 18.2295 78.144 17.4855 78.144ZM31.0619 78.144C30.0179 78.144 29.0879 77.934 28.2719 77.514C27.4559 77.082 26.8139 76.488 26.3459 75.732C25.8899 74.976 25.6619 74.118 25.6619 73.158C25.6619 72.186 25.8899 71.328 26.3459 70.584C26.8139 69.828 27.4559 69.24 28.2719 68.82C29.0879 68.388 30.0179 68.172 31.0619 68.172C32.0819 68.172 32.9699 68.388 33.7259 68.82C34.4819 69.24 35.0399 69.846 35.3999 70.638L33.2219 71.808C32.9699 71.352 32.6519 71.016 32.2679 70.8C31.8959 70.584 31.4879 70.476 31.0439 70.476C30.5639 70.476 30.1319 70.584 29.7479 70.8C29.3639 71.016 29.0579 71.322 28.8299 71.718C28.6139 72.114 28.5059 72.594 28.5059 73.158C28.5059 73.722 28.6139 74.202 28.8299 74.598C29.0579 74.994 29.3639 75.3 29.7479 75.516C30.1319 75.732 30.5639 75.84 31.0439 75.84C31.4879 75.84 31.8959 75.738 32.2679 75.534C32.6519 75.318 32.9699 74.976 33.2219 74.508L35.3999 75.696C35.0399 76.476 34.4819 77.082 33.7259 77.514C32.9699 77.934 32.0819 78.144 31.0619 78.144ZM42.1987 78.144C41.1547 78.144 40.2247 77.934 39.4087 77.514C38.5927 77.082 37.9507 76.488 37.4827 75.732C37.0267 74.976 36.7987 74.118 36.7987 73.158C36.7987 72.186 37.0267 71.328 37.4827 70.584C37.9507 69.828 38.5927 69.24 39.4087 68.82C40.2247 68.388 41.1547 68.172 42.1987 68.172C43.2187 68.172 44.1067 68.388 44.8627 68.82C45.6187 69.24 46.1767 69.846 46.5367 70.638L44.3587 71.808C44.1067 71.352 43.7887 71.016 43.4047 70.8C43.0327 70.584 42.6247 70.476 42.1807 70.476C41.7007 70.476 41.2687 70.584 40.8847 70.8C40.5007 71.016 40.1947 71.322 39.9667 71.718C39.7507 72.114 39.6427 72.594 39.6427 73.158C39.6427 73.722 39.7507 74.202 39.9667 74.598C40.1947 74.994 40.5007 75.3 40.8847 75.516C41.2687 75.732 41.7007 75.84 42.1807 75.84C42.6247 75.84 43.0327 75.738 43.4047 75.534C43.7887 75.318 44.1067 74.976 44.3587 74.508L46.5367 75.696C46.1767 76.476 45.6187 77.082 44.8627 77.514C44.1067 77.934 43.2187 78.144 42.1987 78.144ZM53.4614 78.144C52.3574 78.144 51.3854 77.928 50.5454 77.496C49.7174 77.064 49.0754 76.476 48.6194 75.732C48.1634 74.976 47.9354 74.118 47.9354 73.158C47.9354 72.186 48.1574 71.328 48.6014 70.584C49.0574 69.828 49.6754 69.24 50.4554 68.82C51.2354 68.388 52.1174 68.172 53.1014 68.172C54.0494 68.172 54.9014 68.376 55.6574 68.784C56.4254 69.18 57.0314 69.756 57.4754 70.512C57.9194 71.256 58.1414 72.15 58.1414 73.194C58.1414 73.302 58.1354 73.428 58.1234 73.572C58.1114 73.704 58.0994 73.83 58.0874 73.95H50.2214V72.312H56.6114L55.5314 72.798C55.5314 72.294 55.4294 71.856 55.2254 71.484C55.0214 71.112 54.7394 70.824 54.3794 70.62C54.0194 70.404 53.5994 70.296 53.1194 70.296C52.6394 70.296 52.2134 70.404 51.8414 70.62C51.4814 70.824 51.1994 71.118 50.9954 71.502C50.7914 71.874 50.6894 72.318 50.6894 72.834V73.266C50.6894 73.794 50.8034 74.262 51.0314 74.67C51.2714 75.066 51.6014 75.372 52.0214 75.588C52.4534 75.792 52.9574 75.894 53.5334 75.894C54.0494 75.894 54.4994 75.816 54.8834 75.66C55.2794 75.504 55.6394 75.27 55.9634 74.958L57.4574 76.578C57.0134 77.082 56.4554 77.472 55.7834 77.748C55.1114 78.012 54.3374 78.144 53.4614 78.144ZM63.8938 78.144C63.0658 78.144 62.2678 78.048 61.4998 77.856C60.7438 77.652 60.1438 77.4 59.6998 77.1L60.6358 75.084C61.0798 75.36 61.6018 75.588 62.2018 75.768C62.8138 75.936 63.4138 76.02 64.0018 76.02C64.6498 76.02 65.1058 75.942 65.3698 75.786C65.6458 75.63 65.7838 75.414 65.7838 75.138C65.7838 74.91 65.6758 74.742 65.4598 74.634C65.2558 74.514 64.9798 74.424 64.6318 74.364C64.2838 74.304 63.8998 74.244 63.4798 74.184C63.0718 74.124 62.6578 74.046 62.2378 73.95C61.8178 73.842 61.4338 73.686 61.0858 73.482C60.7378 73.278 60.4558 73.002 60.2398 72.654C60.0358 72.306 59.9338 71.856 59.9338 71.304C59.9338 70.692 60.1078 70.152 60.4558 69.684C60.8158 69.216 61.3318 68.85 62.0038 68.586C62.6758 68.31 63.4798 68.172 64.4158 68.172C65.0758 68.172 65.7478 68.244 66.4318 68.388C67.1158 68.532 67.6858 68.742 68.1418 69.018L67.2058 71.016C66.7378 70.74 66.2638 70.554 65.7838 70.458C65.3158 70.35 64.8598 70.296 64.4158 70.296C63.7918 70.296 63.3358 70.38 63.0478 70.548C62.7598 70.716 62.6158 70.932 62.6158 71.196C62.6158 71.436 62.7178 71.616 62.9218 71.736C63.1378 71.856 63.4198 71.952 63.7678 72.024C64.1158 72.096 64.4938 72.162 64.9018 72.222C65.3218 72.27 65.7418 72.348 66.1618 72.456C66.5818 72.564 66.9598 72.72 67.2958 72.924C67.6438 73.116 67.9258 73.386 68.1418 73.734C68.3578 74.07 68.4658 74.514 68.4658 75.066C68.4658 75.666 68.2858 76.2 67.9258 76.668C67.5658 77.124 67.0438 77.484 66.3598 77.748C65.6878 78.012 64.8658 78.144 63.8938 78.144ZM74.0813 78.144C73.2533 78.144 72.4553 78.048 71.6873 77.856C70.9313 77.652 70.3313 77.4 69.8873 77.1L70.8233 75.084C71.2673 75.36 71.7893 75.588 72.3893 75.768C73.0013 75.936 73.6013 76.02 74.1893 76.02C74.8373 76.02 75.2933 75.942 75.5573 75.786C75.8333 75.63 75.9713 75.414 75.9713 75.138C75.9713 74.91 75.8633 74.742 75.6473 74.634C75.4433 74.514 75.1673 74.424 74.8193 74.364C74.4713 74.304 74.0873 74.244 73.6673 74.184C73.2593 74.124 72.8453 74.046 72.4253 73.95C72.0053 73.842 71.6213 73.686 71.2733 73.482C70.9253 73.278 70.6433 73.002 70.4273 72.654C70.2233 72.306 70.1213 71.856 70.1213 71.304C70.1213 70.692 70.2953 70.152 70.6433 69.684C71.0033 69.216 71.5193 68.85 72.1913 68.586C72.8633 68.31 73.6673 68.172 74.6033 68.172C75.2633 68.172 75.9353 68.244 76.6193 68.388C77.3033 68.532 77.8733 68.742 78.3293 69.018L77.3933 71.016C76.9253 70.74 76.4513 70.554 75.9713 70.458C75.5033 70.35 75.0473 70.296 74.6033 70.296C73.9793 70.296 73.5233 70.38 73.2353 70.548C72.9473 70.716 72.8033 70.932 72.8033 71.196C72.8033 71.436 72.9053 71.616 73.1093 71.736C73.3253 71.856 73.6073 71.952 73.9553 72.024C74.3033 72.096 74.6813 72.162 75.0893 72.222C75.5093 72.27 75.9293 72.348 76.3493 72.456C76.7693 72.564 77.1473 72.72 77.4833 72.924C77.8313 73.116 78.1133 73.386 78.3293 73.734C78.5453 74.07 78.6533 74.514 78.6533 75.066C78.6533 75.666 78.4733 76.2 78.1133 76.668C77.7533 77.124 77.2313 77.484 76.5473 77.748C75.8753 78.012 75.0533 78.144 74.0813 78.144ZM81.3528 78V68.1C81.3528 67.008 81.6768 66.138 82.3248 65.49C82.9728 64.83 83.8968 64.5 85.0968 64.5C85.5048 64.5 85.8948 64.542 86.2668 64.626C86.6508 64.71 86.9748 64.842 87.2388 65.022L86.5008 67.056C86.3448 66.948 86.1708 66.864 85.9788 66.804C85.7868 66.744 85.5828 66.714 85.3668 66.714C84.9588 66.714 84.6408 66.834 84.4128 67.074C84.1968 67.302 84.0888 67.65 84.0888 68.118V69.018L84.1608 70.224V78H81.3528ZM79.8588 70.692V68.532H86.5728V70.692H79.8588ZM92.6828 78.144C91.8788 78.144 91.1588 77.988 90.5228 77.676C89.8988 77.364 89.4128 76.89 89.0648 76.254C88.7168 75.606 88.5428 74.784 88.5428 73.788V68.316H91.3508V73.374C91.3508 74.178 91.5188 74.772 91.8548 75.156C92.2028 75.528 92.6888 75.714 93.3128 75.714C93.7448 75.714 94.1288 75.624 94.4648 75.444C94.8008 75.252 95.0648 74.964 95.2568 74.58C95.4488 74.184 95.5448 73.692 95.5448 73.104V68.316H98.3528V78H95.6888V75.336L96.1748 76.11C95.8508 76.782 95.3708 77.292 94.7348 77.64C94.1108 77.976 93.4268 78.144 92.6828 78.144ZM101.579 78V64.644H104.387V78H101.579Z"
            fill="#003282"
          />
        </svg>
        <div v-else class="flex flex-col">
          <div
            style="width: 27px; height: 27px"
            class="border-red-600 border justify-center items-center rounded-full flex"
          >
            <svg
              width="8"
              height="8"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.5 0.516594C21.1886 0.204506 20.7659 0.0291178 20.325 0.0291178C19.8841 0.0291178 19.4614 0.204506 19.15 0.516594L11 8.64993L2.85001 0.499927C2.53863 0.187839 2.11588 0.0124512 1.67501 0.0124512C1.23415 0.0124512 0.811398 0.187839 0.500012 0.499927C-0.149988 1.14993 -0.149988 2.19993 0.500012 2.84993L8.65001 10.9999L0.500012 19.1499C-0.149988 19.7999 -0.149988 20.8499 0.500012 21.4999C1.15001 22.1499 2.20001 22.1499 2.85001 21.4999L11 13.3499L19.15 21.4999C19.8 22.1499 20.85 22.1499 21.5 21.4999C22.15 20.8499 22.15 19.7999 21.5 19.1499L13.35 10.9999L21.5 2.84993C22.1333 2.21659 22.1333 1.14993 21.5 0.516594Z"
                fill="#F80300"
              />
            </svg>
          </div>
          <div class="text-xs text-red-700 mt-2">Error</div>
        </div>
      </div>

      <p v-if="success" class="text-xs text-center mt-2">
        Statement has been sent to email
      </p>
      <p v-else class="text-xs text-center mt-2">Error retrieving data</p>

      <div class="flex justify-center items-center mt-4">
        <trac-button @click.native="confirmation = false">
          <div class="px-5 leading-4">Close</div>
        </trac-button>
      </div>
    </trac-modal>
    <trac-modal
      v-if="transferToSettlementAccountModalCtrl"
      @close="
        transferToSettlementAccountModalCtrl = false;
        comfirmTransferToSettlementAccount = 1;
      "
    >
      <trac-beneficiary-transfer
        :selectedBeneficiary="currentlySlectedBeneficiary"
        :walletDetails="walletDetails"
        @transferDetailsEmitter="addedTransactionDetails"
        v-if="comfirmTransferToSettlementAccount === 1"
      >
      </trac-beneficiary-transfer>
      <trac-transaction-pin
        :executeBackButton="executeBackButton"
        showBackBtn
        :walletData="walletDetails"
        @add-transaction-pin="addtransactionPin"
        v-if="comfirmTransferToSettlementAccount === 2"
      >
      </trac-transaction-pin>
    </trac-modal>

    <trac-modal @close="closeTransactionModal" v-if="buyAirtimeModalCtrl">
      <trac-network-selection
        @set-service-provider="addServiceProvider"
        v-if="currentAirtimeIndex === 1"
      >
      </trac-network-selection>
      <trac-airtime-data
        @select-type-of-transaction="selectTypeOfTransaction"
        @activate-data-selection="fetchTelcomsDataInfo"
        v-if="currentAirtimeIndex === 2"
        :selectedNetwork="selectedNetwork"
      ></trac-airtime-data>
      <trac-confirm-request
        @got-enter-pin="currentAirtimeIndex += 1"
        :selectedNetwork="selectedNetwork"
        :transactionData="transactionData"
        :walletData="walletDetails"
        v-if="currentAirtimeIndex === 3"
      >
      </trac-confirm-request>
      <trac-transaction-pin
        :selectedNetwork="selectedNetwork"
        :transactionData="transactionData"
        :walletData="walletDetails"
        @add-transaction-pin="addtransactionPin"
        v-if="currentAirtimeIndex === 4"
      >
      </trac-transaction-pin>
      <trac-transaction-success
        :selectedNetwork="selectedNetwork"
        :transactionData="transactionData"
        :responsePayload="responsePayload"
        @close-transaction-modal="closeTransactionModal"
        v-if="currentAirtimeIndex === 5"
      ></trac-transaction-success>
    </trac-modal>

    <trac-modal @close="transferModalCtrl = false" v-if="transferModalCtrl">
      <trac-add-beneficiary
        v-if="currentTransferIndex === 1"
        @select-benficiary="currentTransferIndex += 1"
      >
      </trac-add-beneficiary>
      <trac-transfer-transaction
        v-if="currentTransferIndex === 2"
        @trnasfer-funds="currentTransferIndex += 1"
      >
      </trac-transfer-transaction>
      <trac-transfer-transaction-pin
        v-if="currentTransferIndex === 3"
        @add-transfer-transaction-pin="currentTransferIndex += 1"
      ></trac-transfer-transaction-pin>
      <trac-transaction-success
        @close-transaction-modal="closeTransactionModal"
        v-if="currentTransferIndex === 4"
      >
      </trac-transaction-success>
    </trac-modal>
    <trac-modal
      v-if="fundWalletModal"
      @close="fundWalletModal = false"
      size=" max-w-2xl"
    >
      <div class="p-4">
        <div class="font-semibold text-gray-800">Fund Wallet Via</div>
        <div style="font-size: 12px" class="text-gray-700 mt-1">
          Select your preferred method of funding your wallet
        </div>
        <div class="mt-4 flex">
          <trac-radio value="bank" :selectedVal="type" @change="type = $event">
            Bank Transfer
          </trac-radio>
          <trac-radio
            class="ml-6"
            value="ussd"
            :selectedVal="type"
            @change="type = $event"
          >
            USSD Transfer
          </trac-radio>
        </div>
        <div class="flex justify-end items-end mt-3">
          <trac-button
            @click.native="
              $router.push({
                name: 'FundWallet',
                params: {
                  type,
                },
              })
            "
          >
            <div class="text-xs leading-5 tracking-wide uppercase">
              continue
            </div>
          </trac-button>
        </div>
      </div>
    </trac-modal>
    <trac-modal
      v-if="payBillsModal"
      @close="payBillsModal = false"
      size=" max-w-xl"
    >
      <div class="p-4">
        <div class="text-sm font-bold">Bill Category</div>
        <p class="text-xs text-gray-700 mt-2">Select a bill category below</p>
        <div
          @click="
            $router.push({
              name: 'BillPayment',
              params: {
                type: 'Cable Tv',
              },
            })
          "
          class="flex items-center mt-6 cursor-pointer"
        >
          <svg
            class="w-10 h-10"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="48" height="48" rx="4" fill="#EFFAFF" />
            <path
              d="M30.5 33H17.5C17.22 33 17 32.78 17 32.5C17 32.22 17.22 32 17.5 32H30.5C30.78 32 31 32.22 31 32.5C31 32.78 30.78 33 30.5 33Z"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 28V32"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M28 28V32"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M33.5 28H14.5C14.22 28 14 27.78 14 27.5V15.5C14 15.22 14.22 15 14.5 15H33.5C33.78 15 34 15.22 34 15.5V27.5C34 27.78 33.78 28 33.5 28Z"
              fill="#EFFAFD"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="text-xs text-gray-700 ml-5">Cable TV</p>
        </div>

        <div
          @click="
            $router.push({
              name: 'BillPayment',
              params: {
                type: 'Internet Services',
              },
            })
          "
          class="flex items-center mt-6 cursor-pointer"
        >
          <svg
            class="w-10 h-10"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="48" height="48" rx="4" fill="#EFFAFF" />
            <path
              d="M24 34C29.5228 34 34 29.5228 34 24C34 18.4771 29.5228 14 24 14C18.4771 14 14 18.4771 14 24C14 29.5228 18.4771 34 24 34Z"
              fill="#EFFAFD"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24 34C26.2091 34 28 29.5228 28 24C28 18.4771 26.2091 14 24 14C21.7909 14 20 18.4771 20 24C20 29.5228 21.7909 34 24 34Z"
              fill="#B4E6FF"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.46 27C14.16 26.05 14 25.05 14 24C14 22.95 14.16 21.95 14.46 21H33.54C33.84 21.95 34 22.95 34 24C34 25.05 33.84 26.05 33.54 27H14.46Z"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="text-xs text-gray-700 ml-5">Internet Services</p>
        </div>

        <div
          @click="
            $router.push({
              name: 'BillPayment',
              params: {
                type: 'Utilities',
              },
            })
          "
          class="flex items-center mt-6 cursor-pointer"
        >
          <svg
            class="w-10 h-10"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="48" height="48" rx="4" fill="#EFFAFF" />
            <path
              d="M21.5 29H26.5"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M26.5 32H21.5V33H26.5V32Z"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.36 27H25.64C25.64 27 26.88 25.27 27.75 24.01C28.3 23.19 28.7 22.17 28.7 21.2C28.7 17.84 26.59 16 24 16C21.41 16 19.3 17.84 19.3 21.2C19.3 22.17 19.69 23.19 20.25 24.01C20.39 24.2 22.36 27 22.36 27Z"
              fill="#EFFAFD"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24 22.99V27"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24 23C24.5523 23 25 22.5523 25 22C25 21.4477 24.5523 21 24 21C23.4477 21 23 21.4477 23 22C23 22.5523 23.4477 23 24 23Z"
              fill="#B4E6FF"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M33.9999 20H31.4299"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M32.7301 15L30.3301 16.51"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.57 20H14"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.67 16.51L15.27 15"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="text-xs text-gray-700 ml-5">Utilities</p>
        </div>
        <div class="flex items-center mt-6 cursor-not-allowed">
          <svg
            class="w-10 h-10 opacity-50"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="48" height="48" rx="4" fill="#EFFAFF" />
            <path
              d="M29.31 35H18.69C17.71 35 16.88 34.29 16.72 33.33L15 23H33L31.28 33.33C31.12 34.29 30.28 35 29.31 35Z"
              fill="#EFFAFD"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M27.5 16C29.04 16.06 30.43 16.99 31.04 18.42L33 23H15L16.96 18.42C17.57 16.99 18.96 16.06 20.5 16"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 23H34"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 26.5V31.5"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24 26.5V31.5"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M28 26.5V31.5"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M26.5 17H21.5C20.95 17 20.5 16.55 20.5 16C20.5 15.45 20.95 15 21.5 15H26.5C27.05 15 27.5 15.45 27.5 16C27.5 16.55 27.05 17 26.5 17Z"
              fill="#B4E6FF"
              stroke="#003283"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="text-xs text-gray-500 ml-5">Payment for Supplies</p>
        </div>
      </div>
    </trac-modal>
  </div>
</template>

<script>
import moment from 'moment';
import DateFilter from './DateFilter.vue';

import MakeTransferVue from './beneficiaries/beneficiaries-components/MakeTransfer.vue';
import NetworkSelection from './wallet-components/airtime-transaction/ServiceProviderSelection.vue';
import AirtimeData from './wallet-components/airtime-transaction/AirtimeData.vue';
import ConfirmRequest from './wallet-components/ConfirmRequest.vue';
import TransactionPin from './wallet-components/airtime-transaction/TransactionPin.vue';
import TransactionSuccess from './wallet-components/TransactionSuccess.vue';
import AddBeneficiary from './wallet-components/transafer-transaction/AddBeneficiary.vue';
import ReviewTransferTransactionVue from './wallet-components/transafer-transaction/ReviewTransferTransaction.vue';
import TransferTransactionPin from './wallet-components/transafer-transaction/TransactionPin.vue';
import { eventBus } from './../../eventBus';
import {
  GET_USER_BUSINESS_DATA,
  GET_USER_BUSINESS_ID,
  SAVE_LOCAL_DB_DATA,
  GET_LOCAL_DB_DATA,
} from '../../browser-db-config/localStorage';

import WalletToken from '../security/WalletToken'
import WhiteListingMixin from '../../security-module/WhiteListingMixin';


export default {
  mixins: [WalletToken, WhiteListingMixin],
  components: {
    'trac-network-selection': NetworkSelection,
    'trac-airtime-data': AirtimeData,
    'trac-confirm-request': ConfirmRequest,
    'trac-transaction-pin': TransactionPin,
    'trac-transaction-success': TransactionSuccess,
    'trac-add-beneficiary': AddBeneficiary,
    'trac-transfer-transaction': ReviewTransferTransactionVue,
    'trac-transfer-transaction-pin': TransferTransactionPin,
    'trac-beneficiary-transfer': MakeTransferVue,
    DateFilter,
  },
  data() {
    return {
      fundWalletModal: false,
      moment,
      payBillsModal: false,
      currentAirtimeIndex: 1,
      currentTransferIndex: 1,
      comfirmTransferToSettlementAccount: 1,
      selectedFilter: 'all',
      isLoading: false,
      transferToSettlementAccountModalCtrl: false,
      buyAirtimeModalCtrl: false,
      transferModalCtrl: false,
      selectedNetwork: null,
      transactionData: null,
      transactionPinData: null,
      contents: null,
      walletDetails: null,
      currentlySlectedBeneficiary: null,
      telcoms: null,
      responsePayload: null,
      banks: null,
      transferToSettlementAccountData: null,
      type: 'bank',
      date: {
        startDate: '',
        endDate: '',
      },
      confirmation: false,
      success: false,
      currentName: 'Select Date Range',
      timespan: [
        {
          name: 'Last 7 days',
          value: 7,
        },
        {
          name: 'Last 10 days',
          value: 10,
        },
        {
          name: 'Last 30 days',
          value: 30,
        },
        {
          name: 'Last 90 days',
          value: 90,
        },
      ],
      telcomsData: [
        {
          imgUrl:
            'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/6254147922079755883Frame415.png',
          name: 'mtn',
        },
        {
          imgUrl:
            'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/8719804327786045052Frame413.png',
          name: 'airtel',
        },
        {
          imgUrl:
            'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/4408934263993191813Frame414.png',
          name: 'etisalat',
        },
        {
          imgUrl:
            'https://s3-us-west-1.amazonaws.com/tractionapp-products/pkg/app/uploads/5630710232234883698Frame412.png',
          name: 'glo',
        },
      ],
      // contents: [
      //   {
      //     name: "Starbucks",
      //     paymentMethod: "Pos Transaction",
      //     date: new Date().toISOString(),
      //     transactionId: "1233456789098765",
      //     amount: "+2345606",
      //     balance: 43333333,
      //   },
      //   {
      //     name: "Fractalink des..",
      //     paymentMethod: "Cash",
      //     date: new Date().toISOString(),
      //     transactionId: "1233456789098765",
      //     amount: "-24,2526",
      //     balance: 3891000,
      //   },
      // ],
    };
  },
  computed: {
    hasSetupWallet() {
      return (this.walletDetails || {walletid: ''}).walletid ? true : false
    },
    hasPinChanged() {
      return (this.walletDetails || {haspinchanged: true}).haspinchanged
    },
    filteredTransactions() {
      return (this.contents || []).filter((transaction) => {
        if (this.selectedFilter === 'in') {
          return transaction.isCredit;
        } else if (this.selectedFilter === 'out') {
          return !transaction.isCredit;
        } else {
          return transaction;
        }
      });
    },
  },

  methods: {
    reVerify() {
      // debugger
      this.verifyThenProcess().then(() => {
        this.addtransactionPin(this.temporaryPin)
      })
    },
    addedTransactionDetails(addedTransactionDetail) {
      this.transferToSettlementAccountData = addedTransactionDetail;

      this.comfirmTransferToSettlementAccount += 1;
    },
    async downloadStatement() {
      // console.log(this.data, 'pol');
      if (this.date.startDate === '' || this.date.endDate === '') {
        eventBus.$emit('trac-alert', {
          message: 'Select Date Range',
        });
        return;
      }
      const result = await this.$store.dispatch(
        'FETCH_WALLET_STATEMENT',
        this.date
      );
      this.confirmation = true;
      if (result && result.status) {
        this.success = true;
        this.currentName = 'Select Date Range';
        this.date.startDate = '';
        this.date.endDate = '';
      }
    },
    update(value) {
      this.currentName = value;
    },
    executeBackButton() {
      this.comfirmTransferToSettlementAccount = 1;
    },
    openWalletTransaction(transaction) {
      SAVE_LOCAL_DB_DATA('wallet_transaction', transaction);
      this.$router.push({ name: 'walletTransactionDetails' });
    },
    async selectTimeline(timeline) {
      this.isLoading = true;
      if (!this.walletDetails) {
        await this.fetchWalletDetails();
      }
      await this.fetchTransactionLogs(timeline['value']);

      this.isLoading = false;
    },
    async fetchTransactionLogs(timelineDays) {
      if (this.walletDetails.walletid === '') {
        // this.$router.replace({ name: '' });
        return;
      }
      const transactionsRes = await this.$store.dispatch(
        'FETCH_TRANSACTION_LOGS',
        { ...this.walletDetails, timelineDays }
      );

      if (transactionsRes.status) {
        this.contents = transactionsRes.data || [];
      } else {
        eventBus.$emit('trac-alert', {
          message: "Error: Couldn't get bank details.",
        });
      }
    },
    async fetchAllBankAccounts() {
      await this.$store.dispatch('FETCH_ALL_BANK_ACCOUNTS');
      const res = this.$store.getters['GET_ALL_BANK_ACCOUNTS'];

      if (res.status) {
        this.banks = res.data || [];
        this.currentlySlectedBeneficiary = {
          // bankcode: this.banks[0]['traction_bank_code'],
          // bankname: this.banks[0]['settlement_bank'],
          // accountnumber: this.banks[0]['account_number'],
          // accountname: this.banks[0]['business_name'],
          // // Not really needed in this payload
          // draccountname: GET_USER_BUSINESS_DATA().name,
          // narration: 'Transferred to settlement account.',

          bankcode: this.banks[0]['traction_bank_code'],
          // amount: this.transferToSettlementAccountData.amount,
          accountnumber: this.banks[0]['account_number'],
          accountname: this.banks[0]['business_name'],
          bankname: this.banks[0]['settlement_bank'],
          craccount: this.banks[0]['account_number'],
          craccountname: this.banks[0]['business_name'],
          // Not really needed in this payload
          draccountname: GET_USER_BUSINESS_DATA().name,
          narration: 'Transferred to settlement account.',
        };
      } else {
        // alert(res.message);
        eventBus.$emit('trac-alert', { message: res.message });
      }
    },
    async generateDeviceID() {
      return this.$fpjs
        .getVisitorData({
          extendedResult: true,
        })
        .then((fingerprint) => {
          // console.log("Generated Fingerprint: ", fingerprint.visitorId);
          return fingerprint.visitorId;
        });
    },
    async makeTransferToSettlement(transferDetails) {
      // Check if it's for specific user
      this.makeTransaction('', transferDetails);
    },
    async makeTransaction(deviceId, transferDetails) {
      this.isLoading = true;

      const beneficiaryTransferRes = await this.$store.dispatch(
        'TRANSFER_TO_BENEFICIARY',
        {
          transferDetails: transferDetails || {
            ...this.currentlySlectedBeneficiary,
            amount: this.transferToSettlementAccountData.amount,
          },
          wallet: this.walletDetails,
          deviceID: deviceId,
        }
      );

      if (beneficiaryTransferRes.status) {
        await this.fetchWalletDetails();

        this.transferToSettlementAccountModalCtrl = false;
        this.comfirmTransferToSettlementAccount = 1;
        eventBus.$emit('trac-alert', {
          message:
            beneficiaryTransferRes.message || 'Funds transferred successfully.',
        });
      } else {
        // console.log(beneficiaryTransferRes);
        eventBus.$emit('trac-alert', {
          message:
            beneficiaryTransferRes.message.message ||
            beneficiaryTransferRes.message ||
            "Error: Couldn't make transfer.",
        });
      }
      this.isLoading = false;
    },
    async transferToSettlementAccount() {
      this.isLoading = true;
      await this.fetchAllBankAccounts();

      if (this.currentlySlectedBeneficiary) {
        this.transferToSettlementAccountModalCtrl = true;
        this.transactionData = {
          transactionType: 'transferToSettlementAccount',
        };
      }

      this.isLoading = false;
    },
    async openBuyAirtimeModal() {
      this.isLoading = true;
      const telcomsRes = await this.$store.dispatch('FETCH_PROVIDERS');

      if (telcomsRes.status) {
        const fetchedTelcoms = telcomsRes.data;

        for (let index = 0; index < fetchedTelcoms.length; index++) {
          const element = fetchedTelcoms[index];
          this.telcomsData.forEach((tel) => {
            if (tel.name === element.telcosName) {
              fetchedTelcoms[index] = {
                ...fetchedTelcoms[index],
                img: tel.imgUrl,
              };
            }
          });
        }

        this.telcoms = fetchedTelcoms;
        this.buyAirtimeModalCtrl = true;
      } else {
        eventBus.$emit('trac-alert', {
          message:
            telcomsRes.message || 'Error: Unable to fetch service providers.',
        });
      }
      this.isLoading = false;
    },
    openBeneficiary() {
      this.$router.push({ name: 'WalletBeneficiaries' });
    },
    addServiceProvider(selectedNetwork) {
      console.log('selectedNetwork', selectedNetwork)
      console.log('this.telcoms', this.telcoms)
      const filteredNetwork = this.telcoms.Categories.Airtime.find(
        (telcom) => selectedNetwork.serviceProvider === telcom.ServiceID
      );
      this.selectedNetwork = {...filteredNetwork, serviceProvider: filteredNetwork.ServiceID}
      console.log('filteredNetwork', filteredNetwork)
      this.currentAirtimeIndex += 1;
    },
    async selectTypeOfTransaction(transactionData) {
      this.transactionData = transactionData;
      this.currentAirtimeIndex += 1;
    },
    async addtransactionPin(transactionPinData) {
      this.isLoading = true;
      // this.transactionPinData = transactionPinData;
      // console.log(this.transactionPinData);
      const res = await this.$store.dispatch('VERIFY_USER_PIN', {
        ...transactionPinData,
      });

      if (res.status) {
        const [tokenRes, error] = await this.verifyWalletToken()
        // debugger
        if (tokenRes.status) {
          if (this.transactionData.transactionType === 'airtime') {
            await this.makeAirtimeRequest();
          } else if (
            this.transactionData.transactionType === 'transferToSettlementAccount'
          ) {
            this.makeTransferToSettlement();
          } else {
            this.makeDataRequest();
          }
        }
        else {
          this.isLoading = false;
          this.temporaryPin = transactionPinData
          this.buyAirtimeModalCtrl = false
          this.showPasswordModal = true
        }
      } else {
        this.isLoading = false;
        this.checkIncorrectPin(res)
        this.isSanctioned(res)
        eventBus.$emit('trac-alert', {
          message: res.message || 'Error: Invalid pin',
        });
      }
    },
    closeTransactionModal() {
      this.buyAirtimeModalCtrl = false;
      this.transferModalCtrl = false;
      this.currentAirtimeIndex = 1;
      this.currentTransferIndex = 1;
      this.responsePayload = null;
    },
    async makeDataRequest() {
      this.isLoading = true;
      const dataRequestRes = await this.$store.dispatch('PAY_BILL', {
          amount: parseFloat(this.transactionData.planSelected.variation_amount),
          billerCode: (this.transactionData.phoneNumber).toString(),
          phone: (this.transactionData.phoneNumber).toString(),
          quantity: 1,
          serviceID: `${this.transactionData.service.ServiceID}-data`,
          variation_code: this.transactionData.planSelected.variation_code,
          username: ""
        });

      if (dataRequestRes.status) {
        this.responsePayload = dataRequestRes.data;

        this.currentAirtimeIndex += 1;
      } else {
        eventBus.$emit('trac-alert', {
          message: dataRequestRes.message,
        });
      }
      this.isLoading = false;
    },
    async makeAirtimeRequest() {
      this.isLoading = true;
      const aitimeRequestRes = await this.$store.dispatch(
        'PAY_BILL',
        {
          amount: this.transactionData.planSelected,
          billerCode: (this.transactionData.phoneNumber).toString(),
          phone: (this.transactionData.phoneNumber).toString(),
          quantity: 1,
          serviceID: this.selectedNetwork.ServiceID,
          username: ""
        }
      );

      if (aitimeRequestRes.status) {
        this.currentAirtimeIndex += 1;
        this.buyAirtimeModalCtrl = true;
        this.responsePayload = aitimeRequestRes.data;
      } else {
        eventBus.$emit('trac-alert', {
          message: aitimeRequestRes.message,
        });
      }
      this.isLoading = false;
    },
    async fetchTelcomsDataInfo() {
      const telcomsDataInfoRes = await this.$store.dispatch(
        'FETCH_TELCOMS_DATA_INFO',
        this.selectedNetwork
      );
    },
    async fetchWalletDetails() {
      // this.walletDetails = this.$store.getters["GET_WALLET_DETAILS"] || {})[
      //   "data"
      // ];

      const res = await this.$store.dispatch('FETCH_WALLET_DETAILS');
      this.walletDetails = res.data;

      // this.walletDetails = (this.$store.getters['GET_WALLET_DETAILS'] || {})[
      //   'data'
      // ];

      // if (!this.walletDetails) {

      //   console.log(this.walletDetails);
      // }
    },
  },

  async created() {
    this.isLoading = true;

    if (!this.hasLocalWalletToken()) {
      this.goToWalletAuth()
    } 
    else {
      await this.fetchWalletDetails();
      await this.fetchTransactionLogs(this.timespan[0]['value']);
      this.lockOutAfterInActivity();
      this.isLoading = false;
    }

  },
};
</script>

<style lang="scss" scoped>
.wallet-bg {
  box-shadow: 0px 0px 20px rgba(22, 120, 176, 0.12);
}

.flex-two {
  flex: 2;
}

.wallet-info-cards {
  grid-template-columns: 1fr 30rem;

  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }
}

.max-table-height {
  max-height: 35rem;
}
</style>
